export const tilesConstant = {
  childHeaderText: 'Tool Preventive Maintenance Plan ',
};
